import React, {useState} from 'react';
import {Button, Classes, Colors, Dialog, Icon} from '@blueprintjs/core';
import {useHistory} from 'react-router-dom';
import {IconNames} from '@blueprintjs/icons';

import {ISubscription} from '../../models';
import {subscriptionStartTrial} from '../../services/subscriptionApi';
import {isNoPlan} from './utils';
import config from '../../../config';

import './SubscriptionDialog.scss';

interface ISubscriptionDialogComponentProps {
  show: boolean;
  subscription: ISubscription | undefined | null;
  onClose?: (value?: any) => void | undefined;
}

const TRIAL_PERIOD = 14; // maybe move it to config
const CUSTOMER_NAME = config.app.customer_name;

const SubscriptionPlanText = React.memo(
  ({ subscription }: { subscription: ISubscription | undefined | null }) => {
    if (!subscription) {
      return null;
    }

    if (isNoPlan(subscription)) {
      return (
        <div>
          <p>To execute tasks and Reports, you need an active {CUSTOMER_NAME} subscription.</p>
          <p>You can try {CUSTOMER_NAME} and all of its features for free for {TRIAL_PERIOD}-days.</p>
          <p>No credit card required.</p>
        </div>
      );
    } else {
      return (
        <div>
          <p>To execute tasks and Reports, you need an active {CUSTOMER_NAME} subscription.</p>
          <p>To proceed, <b>upgrade to a paid plan now.</b></p>
        </div>
      )
    }
  }
);

const SubscriptionDialogComponent = ({
  show,
  onClose = undefined,
  subscription = null,
}: ISubscriptionDialogComponentProps) => {
  const [loadingBtn, setLoadingBtn] = useState(false);
  const history = useHistory();

  const checkoutBtnText = isNoPlan(subscription)
    ? 'Start Free Trial'
    : 'Go to Checkout';

  const title = isNoPlan(subscription)
    ? `Start Your ${TRIAL_PERIOD}-day Free Trail`
    : `Upgrade now to unlock all of ${CUSTOMER_NAME} features`;

  const onDialogClose = () => {
    onClose && onClose();
  };

  const onCheckoutClick = (event: any) => {
    setLoadingBtn(true);

    subscriptionStartTrial()
      .then((data?: any) => {
        setLoadingBtn(false);
        onDialogClose();
      })
      .catch(() => setLoadingBtn(false));
  };

  const onUpgradeClick = (event: any) => {
    /*setLoadingBtn(true);

    subscriptionCustomerPortal()
      .then((data: any) => redirectToExternal(data.redirect_url))
      .catch(() => setLoadingBtn(false));*/
    history.push('/a/subscription');
    onDialogClose();
  };

  const onClickFn = isNoPlan(subscription) ? onCheckoutClick : onUpgradeClick;

  return (
    <Dialog
      className="subscription-dialog-container"
      autoFocus={true}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      enforceFocus={true}
      usePortal={true}
      isOpen={show}
      onClose={onDialogClose}
      icon={<Icon icon={IconNames.CLEAN} color={Colors.INDIGO3} />}
      title={title}
    >
      <div className={Classes.DIALOG_BODY + ' subscription-dialog'}>
        <SubscriptionPlanText subscription={subscription} />
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <a
            className="bp4-button"
            target="_blank"
            href="https://pushmetrics.io/book-a-demo/"
          >
            Talk to sales
          </a>
          <Button
            className="subscription-dialog__checkout-button"
            text={loadingBtn ? 'Loading...' : checkoutBtnText}
            onClick={onClickFn}
            disabled={
              loadingBtn
            } /* we don't use loading because of the bg color */
          />
        </div>
      </div>
    </Dialog>
  );
};

const SubscriptionDialog = React.memo(SubscriptionDialogComponent);
export default SubscriptionDialog;
